import _ from 'lodash'
import React from 'react'
import UiSaveButtons from '../components/buttons/UiSaveButtons'
import { appIconTypes } from '../enums/appIconTypes'
import { iconColorTypes } from '../enums/settingsIconTypes'
import Wrapper, { wrapperTypes } from './Wrapper'

const ConfirmationWrapper = ({ showConfirmation, other, handleShow, handleCommit, content, top, updating, allowCommit }) => {

  const footer_confirmation = () => {
    const btns = []
    btns.push({ caption: _.startCase(showConfirmation), color: allowCommit ? iconColorTypes.save : 'teal', oc: handleCommit, icon: appIconTypes.save, opts: { optionType: showConfirmation } })
    btns.push({ caption: handleCommit ? 'Cancel' : 'Close', oc: handleShow, icon: appIconTypes.delete, color: iconColorTypes.remove, fl: true })
    return <UiSaveButtons others={btns} />
  }

  const wrapper_confirmation = () => {
    let header = 'Confirmation: ' + _.startCase(showConfirmation)
    let _top = top ? top : 'Are you sure you want to ' + _.startCase(showConfirmation) + '?'
    if (other) {
      _top += other
    }

    return <Wrapper
      header={header}
      top={handleCommit && _top}
      content={content}
      footer={footer_confirmation()}
      updating={updating}
      wrapperType={wrapperTypes.padded}
    />
  }

  return wrapper_confirmation()
}

export default ConfirmationWrapper
